import { connect } from 'react-redux';
import BinLocations from './BinLocations';
import React from 'react';
import { ILinesHandle, ILinesProperties } from './BinLocations.properties';

const params = new URLSearchParams(location.search);

const mapStateToProps = () => ({
    selectedMovementEnquiryId: params.get('MovementId') || 0,
});

const ContainerComponent = (props: Omit<ILinesProperties, 'classes' | 'calculateCellValueChange'> & { forwardRef?: React.Ref<ILinesHandle> }) => {

    return <BinLocations
        {...props}
        innerRef={props?.forwardRef}
    />;
};

export default connect(mapStateToProps, null)(React.forwardRef(ContainerComponent));
